import React from "react";
import { useParams } from "react-router-dom";
import { RegisterOrganizationMember } from "../containers";

export default function RegisterOrganizationMemberPage() {
    const { token } = useParams();
    if (token) {
        return <RegisterOrganizationMember token={token} />;
    }
    return null;
}
